import {Asset} from "../../entities/Asset";
import {EditBaseCtrl} from "./EditBaseCtrl";
import { StateParams, StateService } from "@uirouter/angularjs";
import {EditAssetModel} from "../../models/edit/EditAssetModel";
import {NotificationService} from "../../services/NotificationService";
import {MaintenanceHistory} from "../../entities/MaintenanceHistory";
import { IEditMaintenanceHandler } from "../../libs/EditMaintenanceHandler/IEditMaintenanceHandler";

export class EditAssetCtrl extends EditBaseCtrl<Asset> {
    $scope:any;
    maintenanceHistoryGridOptions:any;
    childrenGridOptions:any;
    stateParamsService:StateParams;
    editModel:EditAssetModel;
    modal:angular.ui.bootstrap.IModalService;
    b64Object:any;
    public static $inject = ['$window', '$scope', '$state', '$stateParams', '$uibModal', 'NotificationService', 'EditAssetModel'];
    constructor(public $window:Window,
                $scope:any,
                public stateService:StateService,
                stateParamsService:StateParams,
                modal:angular.ui.bootstrap.IModalService,
                public notifyService:NotificationService,
                editModel: EditAssetModel) {
        super($scope, stateService, stateParamsService, notifyService, editModel);
        this.$scope = $scope;
        this.editModel = editModel;
        this.modal = modal;
        $scope.vm = this;
        this.loadData().then((ok)=>{

          this.$scope.$watch(() => this.model.entity.maintenanceStartDate,(newValue: any, oldValue: any) => {
            if(newValue != oldValue) {
              this.editModel.setNextMaintenance();
            }
          });
          this.$scope.$watch(() => this.model.entity.maintenanceSingleDate,(newValue: any, oldValue: any) => {
            if(newValue != oldValue) {
              this.editModel.setNextMaintenance();
            }
          });
          if(this.id != null) {
            this.editModel.loadSecondaryData(this.id).then((ok)=> {
              this.maintenanceHistoryGridOptions.data = this.editModel.allMaintenanceHistories;
              this.childrenGridOptions.data = this.editModel.allChildren;
            });
          }
          else{
              this.getEntityNameSerial();
          }
          this.$scope.$watch(() => this.b64Object,(newValue: any, oldValue: any) => {
            if(newValue != oldValue && newValue != null) {
              var b64Val = newValue.base64;
              this.editModel.uploadImage(b64Val).then(()=>{
              });
            }
          });
        });
        this.maintenanceHistoryGridOptions = {
            multiSelect:false,
            columnDefs: [{ width: 200, field: 'whenPerformed', name: 'When Performed', cellFilter: 'date:\'yyyy-MM-dd\'' }, { width: 300, field: 'actionPerformed', name: 'Action Performed' }, { width: 200, field: 'performedBy', name: 'Performed By' }, { width: 400, field:'notes',name:'Notes'}],
            data:[],
            onRegisterApi:function(gridApi:any) {
                gridApi.selection.on.rowSelectionChanged($scope,function(row:any) {
                    var entity = row.entity;
                    if (row.isSelected) {
                        $scope.vm.model.selectedMaintenance = entity;
                    }
                    else {
                        $scope.vm.model.selectedMaintenance = null;
                    }
                });
            }
        };
        this.childrenGridOptions = {
          multiSelect:false,
          columnDefs:[{field:'name',name:'Name'},{field:'description',name:'Description'},{field:'locationName',name:'Location Name'}],
          data:[],
          onRegisterApi:function(gridApi:any) {
            gridApi.selection.on.rowSelectionChanged($scope,function(row:any) {
              var entity = row.entity;
              if (row.isSelected) {
                $scope.vm.model.selectedAsset = entity;
              }
              else {
                $scope.vm.model.selectedAsset = null;
              }
            });
          }
        };
    }
    getEntityNameSerial(forceLoad:boolean = false){
        this.editModel.loadEntityNameSerial(forceLoad).then((name)=>{
            this.editModel.entity.name =  name;
        });
    }
    pagingRoute():string{
      return "admin.assets";
    }
    removeImage():void{
      this.b64Object = null;
      this.editModel.removeImage();
    }
    addChild():void{
      //var maint = new MaintenanceHistory();
      //maint.assetID = this.model.entity.id;
      console.log("addChild");
      this.openChildDialog(this.model.entity).then((childAssets:Asset[])=>{
        for(var i=0;i<childAssets.length;i++) {
          var childAsset: Asset = childAssets[i];
          if (childAsset != null) {
            var added: boolean = this.editModel.addChild(childAsset);
            if (added)
              this.childrenGridOptions.data.push(childAsset);
          }
        }
      });
    }
    viewParent():void{

    }
    deleteChild():void{
      var child = this.editModel.selectedAsset;
      if(child == null)
        return;
      this.editModel.deleteChild(child);
      var index = this.childrenGridOptions.data.indexOf(child);
      this.childrenGridOptions.data.splice(index,1);
    }
    addMaintenance():void{
        var maint = new MaintenanceHistory();
        maint.assetID = this.model.entity.id;
        console.log("addMaint");
        this.openMaintenanceDialog(maint).then((ok)=>{
            if(ok){
                this.editModel.addMaintenance(maint);
                this.maintenanceHistoryGridOptions.data.push(maint);
            }
        });
    }
    editMaintenance():void{
        var maint = this.editModel.selectedMaintenance;
        if(maint == null)
            return;
        this.openMaintenanceDialog(maint).then((ok)=>{
            if(ok){
                this.editModel.editMaintenance(maint);
            }
        });
    }
    deleteMaintenance():void{
        var maint = this.editModel.selectedMaintenance;
        if(maint == null)
            return;
        this.editModel.deleteMaintenance(maint);
        var index = this.maintenanceHistoryGridOptions.data.indexOf(maint);
        this.maintenanceHistoryGridOptions.data.splice(index,1);

    }
  openChildDialog(parentAsset:Asset):ng.IPromise<Asset[]>{
    console.log("ocd");
    var modalInstance:angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
      animation: true,
      template: require('../../../views/admin.pickchild.html').default,
      controller: 'PickChildCtrl',
      size: 'lg',
      resolve: {
        parentAsset: function () {
          return parentAsset;
        }
      }
    });

    return modalInstance.result;
  }
    openMaintenanceDialog(maintenance:MaintenanceHistory):ng.IPromise<boolean>{
        console.log("omd");
        var modalInstance:angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
            animation: true,
            template: require('../../../views/admin.editmaintenance.html').default,
            controller: 'EditMaintenanceCtrl',
            size: 'lg',
            resolve: {
                maintenance: function () {
                    return maintenance;
                }
            }
        });

        return modalInstance.result;
    }
    openMap():void{
        this.$window.open('https://www.google.com/maps/search/?api=1&query='+this.model.entity.latitude+','+this.model.entity.longitude, '_blank');
    }
    openPrintDialog():void{
        if(this.model.entity.id == null && (this.model.entity.name == null || this.model.entity.name.length==0))
        {
            alert("Please enter an asset name first before printing.");
            return;
        }
        var modalInstance:angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
            animation: true,
            template: require('../../../views/admin.print.html').default,
            controller: 'PrintCtrl',
            size: 'lg',
            resolve: {
                totalCount: function () {
                    return 1;
                },
                templateType: function () {
                    return "Asset"
                }
            }
        });
        modalInstance.result.then((template)=>{
            this.editModel.print(template);
        })
    }
}
